import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { GridParameterFilter } from '../../Networking';
import { TableFilterProps } from './interfaces';

export interface FilterStateWrapperProps {
  columnFilter: (props: TableFilterProps) => React.ReactNode;
  filter?: GridParameterFilter[];
  setFilter: (filter: GridParameterFilter[] | undefined) => void;
  visible: boolean;
}

export const FilterStateWrapper: React.FC<FilterStateWrapperProps> = ({
  filter,
  setFilter,
  visible,
  columnFilter,
}) => {
  const [internalFilter, setInternalFilter] = useState(filter);

  useEffect(() => {
    if (visible) {
      setInternalFilter(filter);
    }
  }, [filter, visible]);

  const onConfirm = () => {
    if (internalFilter) {
      setFilter([...internalFilter]);
    } else {
      setFilter(undefined);
    }
  };

  const onClear = () => {
    setFilter(undefined);
  };

  return (
    <>
      {columnFilter({
        filters: [...(internalFilter ?? [])],
        setFilters: setInternalFilter,
        visible,
        onConfirm,
        onClear,
      })}
    </>
  );
};
